import * as z from 'zod';

import { type UpdateLoanRow, UpdateLoanRowRefinements } from '@willow/types-iso';

import { validateLateFeeFields } from '../create/crossFieldParsers/validateFeeFields';

const hasAcquiredLoanFields = (data: UpdateLoanRow, ctx: z.RefinementCtx) => {
  if (data.isAcquired === true && (data.acquisitionDate == null || data.acquisitionDate === '')) {
    ctx.addIssue({
      code: 'custom',
      message: 'Acquired loan must have `acquisitionDate`.',
      path: ['isAcquired'],
    });
  }
};

export const UpdateLoanCrossFieldParser =
  UpdateLoanRowRefinements.superRefine(hasAcquiredLoanFields).superRefine(validateLateFeeFields);
